import { useFieldArray, useFormContext } from "react-hook-form";
import { LotsSubComponent } from "../lots";
import { BgFormType } from "@services/guarantees/types";
import { useBgFormContext } from "@app/guranteeFormWrapper";
import { BeneficiaryItem } from "./beneficiaryItem";

export const Beneficiaries = ({ lotIndex }: LotsSubComponent) => {
  const { control } = useFormContext<BgFormType>();
  const { formDisabled, prefix } = useBgFormContext();

  const currentPrefix = (prefix ? `${prefix}.purchase.lots` : "purchase.lots") as "purchase.lots";

  const { fields: beneficiaries, remove } = useFieldArray({
    control,
    name: `${currentPrefix}.${lotIndex}.beneficiaries` as `purchase.lots.${number}.beneficiaries`,
  });

  const onRemove = (idx: number) => remove(idx);

  return (
    <>
      {beneficiaries.map((beneficiary, bIdx) => (
        <BeneficiaryItem
          key={beneficiary.id}
          lotIndex={lotIndex}
          bIdx={bIdx}
          onRemove={onRemove}
          removable={beneficiaries.length > 1 && !formDisabled}
        />
      ))}
    </>
  );
};
